const MicrosoftIconLogin = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2274_441)">
            <path d="M11.4062 11.4062H0V0H11.4062V11.4062Z" fill="#F1511B" />
            <path d="M24.0001 11.4062H12.594V0H24.0001V11.4062Z" fill="#80CC28" />
            <path d="M11.4059 24.0002H0V12.594H11.4059V24.0002Z" fill="#00ADEF" />
            <path d="M24.0001 24.0002H12.594V12.594H24.0001V24.0002Z" fill="#FBBC09" />
        </g>
        <defs>
            <clipPath id="clip0_2274_441">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default MicrosoftIconLogin;